export type ValidationErrors<T> = Partial<Record<keyof T, string>>;

export function validateRequiredFields<T extends Record<string, any>>(
  values: T,
  requiredFields: (keyof T)[]
): ValidationErrors<T> {
  const errors: ValidationErrors<T> = {};

  requiredFields.forEach((field) => {
    const value = values[field];

    if (
      value === null ||
      value === undefined ||
      value === "" ||
      (typeof value === "number" && isNaN(value))
    ) {
      errors[field] = "This field is required";
    }
  });

  return errors;
}


export function scrollToFirstError(errors: Record<string, any>) {
  const firstErrorKey = Object.keys(errors)[0];
  if (!firstErrorKey) return;

  const element = document.getElementById(firstErrorKey);
  if (element) {
    element.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });

    const input = element.querySelector("input, button");
    if (input instanceof HTMLElement) {
      input.focus();
    }
  }
}